import { z } from 'zod/v3';
import { transformNullish } from '../../../../common/utils/schema';
import { AlgorithmTargetRuleFormDataSchema } from './AlgorithmTargetRuleFormDataSchema';

export const AlgorithmTargetFormDataSchema = z.object({
  id: transformNullish<number>(z.number(), -1),
  algorithmId: z.number(),
  condition: transformNullish<string>(z.string(), ''),
  description: transformNullish<string>(z.string(), ''),
  sequenceNumber: transformNullish<number | undefined>(z.number(), undefined),
  targetKey: transformNullish<string>(z.string(), ''),
  rules: transformNullish<
    z.output<typeof AlgorithmTargetRuleFormDataSchema>[],
    z.input<typeof AlgorithmTargetRuleFormDataSchema>[]
  >(AlgorithmTargetRuleFormDataSchema.array(), []),
});
